import {
  createReqConsts,
  createActions,
  createReqWatcher,
  initialState as rootState,
  createReqReducer,
} from '../../../utils/redux';
import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';

const makeRequestConfig = (slug = []) => ({
  endpoint: 'patients',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['patientUserId'],
    },
    'primary_care_provider',
    {
      type: 'payload.query',
      queryParameter: 'organization_id',
      selector: 'organizationId',
    },
    ...slug,
  ],
});

const requestOptions = makeRequestConfig();

export const consts = createReqConsts(
  'appointment-form',
  'primary-provider-data',
);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, requestOptions, true);

const defaultRequestReducer = createReqReducer(consts);

const initialState = {
  ...rootState,
  data: {
    answer: null,
    considerUs: null,
    pcpName: null,
    primaryCareProvider: null,
  },
};

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.SUCCEED:
      return {
        ...state,
        succeed: true,
        sending: false,
        data: payload,
      };

    case APPOINTMENT_PROGRESS_TYPES.CLEAR: {
      return initialState;
    }

    default:
      return defaultRequestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/primary-provider-data.js